import React, { useEffect, useRef, useState } from 'react'
import { Loader } from '@googlemaps/js-api-loader'

const parcourStyles = (feature) => ({
  icon: feature.getProperty('icon'),
  title: feature.getProperty('name'),
  fillColor: feature.getProperty('color'),
  fillOpacity: feature.getProperty('opacity'),
  strokeColor: feature.getProperty('stroke'),
  strokeOpacity: feature.getProperty('stroke-opacity'),
  strokeWeight: feature.getProperty('stroke-width'),
  visible: feature.getProperty('visible') || true,
})

const poiStyles = (feature) => ({
  icon: feature.getProperty('icon'),
  title: feature.getProperty('name'),
  fillOpacity: feature.getProperty('opacity'),
  visible: feature.getProperty('visible') || true,
})

const addDataLayers = (google, baseMap, setPoiContent, objs, styleObj) =>
  objs.reduce((map, obj) => {
    // we only show layers by default if the property obj.initialSelected is true
    let layer = new google.maps.Data({
      map: obj.initialSelected ? baseMap : null,
    })
    layer.addGeoJson(obj.location)
    layer.setStyle((feature) => styleObj(feature))
    layer.addListener('click', (event) => setPoiContent(event.feature))
    map.push({
      id: obj._id,
      name: obj.name,
      dataLayer: layer,
      initialSelected: obj.initialSelected,
    })
    return map
  }, [])

const addPoiLayers = (google, baseMap, setPoiContent, parcours, atmosphericareas, pois) => {
  let startFinishLayers = []
  let atmosphericAreasLayers = []
  let poiLayers = []
  if (parcours) {
    startFinishLayers = addDataLayers(google, baseMap, setPoiContent, parcours, parcourStyles)
  }
  if (atmosphericareas) {
    atmosphericAreasLayers = addDataLayers(
      google,
      baseMap,
      setPoiContent,
      atmosphericareas,
      parcourStyles
    )
  }
  if (pois) {
    poiLayers = addDataLayers(google, baseMap, setPoiContent, pois, poiStyles)
  }
  return [...poiLayers, ...startFinishLayers, ...atmosphericAreasLayers]
}

const removePoi = [
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }],
  },
]

const GoogleMap = ({
  setBaseMap,
  event,
  parcours,
  atmosphericareas,
  pois,
  setPoiLayers,
  setPoiContent,
  setCurrentLocationMarker,
  setDirectionsService,
  setDirectionsRenderer,
}) => {
  const mapRef = useRef(null)
  const [errorElement, setErrorElement] = useState(undefined)

  useEffect(async () => {
    const loader = new Loader({
      apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
      version: 'weekly',
    })

    try {
      const google = await loader.load()
      setDirectionsService(new google.maps.DirectionsService())
      const baseMap = new google.maps.Map(mapRef.current, {
        zoom: event.centerPoint.zoom,
        center: event.centerPoint.center,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        streetViewControl: false,
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        styles: removePoi,
      })

      setDirectionsRenderer(
        new google.maps.DirectionsRenderer({ map: baseMap, suppressMarkers: true })
      )
      // init currentLocation marker
      setCurrentLocationMarker(
        new google.maps.Marker({
          map: baseMap,
          icon: '/assets/pois/currentLocation.svg',
          visible: false,
        })
      )
      setBaseMap(baseMap)
      setPoiLayers(addPoiLayers(google, baseMap, setPoiContent, parcours, atmosphericareas, pois))
    } catch {
      setErrorElement(<p>Er ging wat mis tijdens het laden van de kaart</p>)
    }
  }, [event, parcours, atmosphericareas, pois, setPoiLayers, setErrorElement])

  return (
    <>
      {!errorElement && <div id='map' ref={mapRef} />}
      {errorElement}
    </>
  )
}

export default GoogleMap
